<template>
  <v-app :style="{ background: '#f7f3f2' }">
    <v-content>
      <router-view :key="$route.fullPath"></router-view>
      <v-snackbar top right color="error" dark :value="error.status" vertical>
        <div v-for="(m, i) in error.message" :key="i">
          <v-icon left> mdi-alert-circle</v-icon>
          {{ m }}
        </div>
      </v-snackbar>
    </v-content>
    <v-footer app inset>
      <span class="caption">
        Copyright &copy; {{ new Date().getFullYear() }}
        <a href="http://ecozensolutions.com">Ecozen Solutions</a>. All rights
        reserved.
      </span>
      <v-spacer />
      <span class="caption"> Version 4.0.0</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  computed: {
    error() {
      return this.$store.state.error;
    }
  }
};
</script>
